import styled, { css } from 'styled-components';
import { HeadingStyle } from 'components/heading';
import { TextStyle } from 'components/text';
import { spacing } from 'commons';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 50px;
  gap: 20px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  gap: 10px;

  ${HeadingStyle} {
    color: ${({ theme }) => theme.danger_500};
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 350px;
  gap: 10px;
`;

export const Textarea = styled.textarea`
  flex: 1;
  resize: none;
  padding: 15px;
  outline: none;
  border-radius: ${spacing.input.borderRadius};
  border: 1px solid ${({ theme }) => theme.neutral_500};
  background-color: ${({ theme }) => theme.neutral_100};
  color: ${({ theme }) => theme.neutral_500};

  font-size: 12px;
  font-weight: 300;
`;

export const CharacterCounterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`;

export const TextareaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  ${TextStyle} {
    display: flex;
    gap: 4px;

    .opaque {
      color: ${({ theme }) => theme.neutral_700};
      opacity: 0.5;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
`;

export const ProductListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const PRODUCT_BORDER_RADIUS = '8px';

export const ProductWrapper = styled.div<{ $selected: boolean }>`
  background-color: ${({ theme }) => theme.neutral_300};
  border-radius: ${PRODUCT_BORDER_RADIUS};
  display: flex;
  cursor: pointer;

  & > div:last-child {
    border-radius: 0 ${PRODUCT_BORDER_RADIUS} ${PRODUCT_BORDER_RADIUS} 0;
  }

  ${({ $selected, theme }) =>
    $selected &&
    css`
      background-color: ${theme.danger_500};
    `}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
`;

export const Checkbox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.neutral_100};
  color: ${({ theme }) => theme.danger_500};
`;
